import React from 'react';
import {paymentSuccess} from '../../actions/paymentActions';
import { useDispatch } from 'react-redux'


export default function TotalModal(props) {
  
  
  var subtotal_price = 0;
  var gateway_credit_card = 0;

  for (let i = 0; i < props.data.length; i++) {
    let data = props.data[i];
    subtotal_price = subtotal_price + data.interest_payable ;
  }
  sessionStorage.setItem('QR_price_int', subtotal_price.toFixed(2) );
  
  var subtotal_price = 0;
  
  for (let i = 0; i < props.data.length; i++) {
    let data = props.data[i];
    subtotal_price = subtotal_price + data.interest_payable + 2.0;
  }
  

  var payment_type=sessionStorage.getItem('payment_type')  

    
  var payment = ""
  if (payment_type==='creditcard') {payment = "CREDIT CARD"}
  if (payment_type==='pawnow') {payment = "PAYNOW"}

  
  

  gateway_credit_card =  0
    subtotal_price = subtotal_price + 0;

  


  var admin_price = 0;
  
  for (let i = 0; i < props.data.length; i++) {
    let data = props.data[i];
    admin_price = admin_price + 2.0;
  }
    

  var gateway_total = 0 ;
  
  gateway_total = gateway_credit_card + admin_price ;

  sessionStorage.setItem('gateway_credit_card', gateway_credit_card.toFixed(2) );
  sessionStorage.setItem('admin_price', admin_price.toFixed(2) );
  sessionStorage.setItem('QR_price', subtotal_price.toFixed(2) );
  sessionStorage.setItem('gateway_total', gateway_total.toFixed(2) );
  
  //  subtotal_price='3.33'
 var k = props.data.length;
 
 sessionStorage.setItem('total_count', k );
 
 subtotal_price=sessionStorage.getItem('QR_price_int')

  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  return (
  <div>Interest: 
    <br></br>
    {formatter.format(subtotal_price)}
  </div>
  

);
}
